import React from 'react'
import { renderToString } from 'react-dom/server'
import { JsonLd } from 'react-schemaorg'
import { FAQPage } from 'schema-dts'
import { generateFaqList } from 'src/components/page/faq/faqList'
import { useStockReportContext } from 'src/contexts/stock-report.context'
import striptags from 'striptags'

export const FAQPageSchema: React.FC = () => {
  const { report } = useStockReportContext()

  if (!report) {
    return null
  }

  return (
    <JsonLd<FAQPage>
      item={{
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: generateFaqList(report).map((item) => {
          let text: string

          let answer = renderToString(item.answer)
          const listRegex = /<\/li><li>/gi
          if (listRegex.test(answer)) {
            answer = answer.replace(listRegex, ', ')
          }

          text = striptags(answer)

          return {
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text,
            },
          }
        }) as any,
      }}
    />
  )
}
